// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"67bdbbde","453":"e0a9e096","455":"56e8146b","977":"1846c8b4"}[chunkId] + ".chunk.js";
};